module.exports = __webpack_public_path__ + "assets/img/useravatar_2.7f501219.png";